import { createAction, props } from "@ngrx/store";
import { ListarComunicadosInputDto } from "src/app/domain/DTOs/input/listar-comunicados.input.dto";
import { ComunicadoOutputDto } from "src/app/domain/DTOs/output/comunicado.output.dto";
import { EstruturaRetornoDadosPaginadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados-paginados.output.dto";

const actionName = "[ ListarComunicados ] Listar comunicados";

export const listarComunicados = createAction(
  actionName,
  props<{ listarComunicadosInputDto: ListarComunicadosInputDto}>()
);

export const listarComunicadosSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosPaginadosOutputDto<ComunicadoOutputDto[]> }>()
);

export const listarComunicadosFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoDadosPaginadosOutputDto<ComunicadoOutputDto[]> }>()
);

export const listarComunicadosFinish = createAction(
  `${actionName} - Concluir`
);